import React from 'react';

interface FormInputProps {
  id: string;
  name: string;
  label: React.ReactNode;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: 'text' | 'email' | 'number' | 'tel';
  placeholder?: string;
  required?: boolean;
  error?: string;
  width?: 'full' | 'half';
  className?: string; // Added className prop for additional styling
}

export const FormInput: React.FC<FormInputProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  type = 'text',
  placeholder,
  required = false,
  error,
  width = 'full',
  className = '',
}) => {
  return (
    <div className={`form-group ${width === 'half' ? 'half-width' : ''} ${className}`}>
      <label htmlFor={id}>
        {label}
        {required && <span className="required">*</span>}
      </label>
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="modern-input" // Added a class for consistent styling
      />
      {error && <span className="form-error">{error}</span>}
    </div>
  );
};